var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Linesheets_Icon_-_Black",
    "data-name": "Linesheets Icon - Black",
    width: 600,
    height: 600,
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456.684,
    height: 479.195,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.406,
    y1: 0.607,
    x2: 0.868,
    y2: 0.082,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1c1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#373735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#626160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#515150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#282827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.091,
    y1: 0.909,
    x2: 0.909,
    y2: 0.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.091,
    y1: 0.909,
    x2: 0.909,
    y2: 0.091,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.258,
    y1: 0.741,
    x2: 0.53,
    y2: 0.469,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39872",
    "data-name": "Path 39872",
    d: "M982.225,605.884c-106.8-104.1-319-69.264-333.59-70.98-39.835-4.691-27.049-55.039-20.773-83.909,26.176-120.458-1.406-232.324-33.982-254.662C624.348,217.227,907.317,495.59,982.225,605.884Z",
    transform: "translate(-593.879 -196.332)",
    fill: "#262626",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.073,
    y1: 0.927,
    x2: 0.49,
    y2: 0.51,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_2_6",
    "data-name": "Component 2 \\u2013 6",
    transform: "translate(0, 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39874",
    "data-name": "Path 39874",
    d: "M117.133,0H339.387c64.691,0,117.133,54.722,117.133,122.225V356.138c0,67.5-52.441,122.222-117.129,122.222H117.133C52.442,478.36,0,423.638,0,356.134V122.225C0,54.722,52.442,0,117.133,0Z",
    transform: "translate(0.165 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39875",
    "data-name": "Path 39875",
    d: "M15.152,0H80.612A15.152,15.152,0,0,1,95.764,15.152V80.615A15.142,15.142,0,0,1,80.622,95.758H15.142A15.142,15.142,0,0,1,0,80.615V15.152A15.152,15.152,0,0,1,15.152,0Z",
    transform: "translate(55.446 197.002)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39876",
    "data-name": "Path 39876",
    d: "M15.142,0h65.47A15.152,15.152,0,0,1,95.764,15.152V80.615A15.142,15.142,0,0,1,80.622,95.758H15.142A15.142,15.142,0,0,1,0,80.615V15.142A15.142,15.142,0,0,1,15.142,0Z",
    transform: "translate(55.446 328.197)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39877",
    "data-name": "Path 39877",
    d: "M15.142,0H80.615A15.148,15.148,0,0,1,95.764,15.149V80.615A15.142,15.142,0,0,1,80.621,95.758H15.152A15.152,15.152,0,0,1,0,80.606V15.142A15.142,15.142,0,0,1,15.142,0Z",
    transform: "translate(176.487 328.197)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18681",
    "data-name": "Group 18681",
    transform: "translate(55.446 59.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39878",
    "data-name": "Path 39878",
    d: "M29.814,0H65.944a29.82,29.82,0,0,1,29.82,29.82V65.938a29.82,29.82,0,0,1-29.82,29.82H29.82A29.82,29.82,0,0,1,0,65.938V29.814A29.814,29.814,0,0,1,29.814,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39879",
    "data-name": "Path 39879",
    d: "M29.814,0H65.947A29.817,29.817,0,0,1,95.764,29.817V65.938a29.82,29.82,0,0,1-29.82,29.82H29.82A29.82,29.82,0,0,1,0,65.938V29.814A29.814,29.814,0,0,1,29.814,0Z",
    transform: "translate(121.05 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39881",
    "data-name": "Path 39881",
    d: "M29.814,0H65.941a29.82,29.82,0,0,1,29.82,29.82V65.938a29.82,29.82,0,0,1-29.82,29.82H29.82A29.82,29.82,0,0,1,0,65.938V29.814A29.814,29.814,0,0,1,29.814,0Z",
    transform: "translate(242.099 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39880",
    "data-name": "Path 39880",
    d: "M29.811,0H65.947A29.817,29.817,0,0,1,95.764,29.817V65.938a29.82,29.82,0,0,1-29.82,29.82H29.82A29.82,29.82,0,0,1,0,65.938V29.811A29.811,29.811,0,0,1,29.811,0Z",
    transform: "translate(121.05 131.438)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39882",
    "data-name": "Path 39882",
    d: "M29.811,0h36.13a29.82,29.82,0,0,1,29.82,29.82V65.947A29.811,29.811,0,0,1,65.95,95.758H29.82A29.82,29.82,0,0,1,0,65.938V29.811A29.811,29.811,0,0,1,29.811,0Z",
    transform: "translate(242.099 131.438)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39883",
    "data-name": "Path 39883",
    d: "M29.81,0h36.13a29.82,29.82,0,0,1,29.82,29.82V65.947A29.811,29.811,0,0,1,65.95,95.758H29.82A29.82,29.82,0,0,1,0,65.938V29.81A29.81,29.81,0,0,1,29.81,0Z",
    transform: "translate(242.099 262.872)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39870",
    "data-name": "Path 39870",
    d: "M621.645,196.332a124.346,124.346,0,0,0-40.208,92.02V522.93c0,67.7,52.444,122.572,117.133,122.572H920.825c35.636,0,67.533-16.676,89.017-42.948Z",
    transform: "translate(-581.438 -166.307)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18683",
    "data-name": "Group 18683",
    transform: "translate(40.221 30.026)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39871",
    "data-name": "Path 39871",
    d: "M982.225,605.884c-106.8-104.1-319-69.264-333.59-70.98-39.835-4.691-27.049-55.039-20.773-83.909,26.176-120.458-1.406-232.324-33.982-254.662C624.348,217.227,907.317,495.59,982.225,605.884Z",
    transform: "translate(-593.879 -196.332)",
    fill: "#262626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18682",
    "data-name": "Group 18682",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    d: "M41.652,0H483.02a41.655,41.655,0,0,1,41.655,41.655v470.51a41.655,41.655,0,0,1-41.655,41.655H41.656A41.656,41.656,0,0,1,0,512.165V41.652A41.652,41.652,0,0,1,41.652,0Z",
    transform: "translate(-136.986 1.31)",
    fill: "#262626"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39873",
    "data-name": "Path 39873",
    d: "M594.055,196.391c.272.217,243.6,256.326,389.192,409.362-84.947-87.077-324.425-63.627-339.255-65.37-38.517-4.533-27.524-53.957-21.456-81.87C654.886,309.626,594.055,196.391,594.055,196.391Z",
    transform: "translate(-553.26 -166.175)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.0c03bf7f6ed1f8e9614e953d055e586e.svg";
export { ForwardRef as ReactComponent };